/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { leadsGet } from "../../funcs/leadsGet.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request:
    operations
      .GetApiLeadScraperMicroserviceApiV1LeadsLeadIdRequest$inboundSchema,
};

export const tool$leadsGet: ToolDefinition<typeof args> = {
  name: "leads_get",
  description: `Get lead details

Retrieves detailed information about a specific lead`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await leadsGet(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
